import CodeHighLighter from '@/lib/HighLighter';
import CopyToClipboard from 'react-copy-to-clipboard';
import { useState } from 'react';

interface ToastHighLighterProps {
  name: string;
  codeString: string;
  language: string;
  show: boolean;
  disableCopy?: boolean;
}

const ToastHighLighter: React.FC<ToastHighLighterProps> = ({
  name,
  codeString,
  language,
  show,
  disableCopy = false,
}) => {
  const [state, setState] = useState<boolean>(false);

  const handleClick = () => {
    setState(true);
    setTimeout(() => {
      setState(false);
    }, 5000);
  };

  return (
    <>
      <button
        className="btn btn-light btn-sm text-uppercase"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#${name}`}
        aria-expanded={`${show ? 'true' : 'false'}`}
        aria-controls={name}
      >
        {language}
      </button>
      {disableCopy === false ? (
        <CopyToClipboard text={codeString}>
          <button className="btn btn-info btn-sm" onClick={handleClick}>
            Code kopieren
          </button>
        </CopyToClipboard>
      ) : (
        false
      )}

      <div className={`collapse ${show ? 'show' : false}`} id={name}>
        <div className="card card-body highlighter">
          <CodeHighLighter codeString={codeString} language={language} />
        </div>
      </div>

      <div className="position-fixed top-0 end-0 p-3" style={{ zIndex: 1100 }}>
        <div
          id="liveToast"
          className={`toast ${state ? 'show' : 'hide'}`}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="toast-header">
            <strong className="me-auto">Code copied to clipboard</strong>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="toast"
              aria-label="Close"
            ></button>
          </div>
          <div className="toast-body">
            <CodeHighLighter codeString={codeString} language={language} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ToastHighLighter;
